import * as React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

import { TTextType, Typography } from '@ts/storybook';

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      //backgroundColor: theme.palette.common.white,
      //color: 'rgba(0, 0, 0, 0.87)',
      //boxShadow: theme.shadows[1],
      fontSize: 14,
    },
  })
);

export interface ITooltipProps extends TooltipProps {
  title: TTextType;
  disabled?: boolean;
  className?: string;
  isInRight?: boolean; //To see the tooltip in the right
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}
const TTooltip: React.FC<ITooltipProps> = props => {
  const [open, setOpen] = React.useState(false);

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  return (
    <StyledTooltip
      open={props.disabled ? false : open}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      PopperProps={
        props.isInRight
          ? {
              placement: 'bottom',
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [2000, 40],
                  },
                },
              ],
            }
          : {}
      }
      placement={props.placement || 'bottom'}
      className={props.className}
      title={<Typography variant="body1" text={props.title} />}
      sx={props.sx}
    >
      <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        {props.children}
      </span>
    </StyledTooltip>
  );
};

export default TTooltip;
